/**
 * Parse a date string as UTC.
 * If the string has no timezone indicator (Z or +), append "Z" so the
 * browser interprets it as UTC instead of local time.
 *
 * @param dateStr ISO date string from the API.
 * @returns A Date object, or null when the input is empty/nullish.
 */
export function parseUTC(dateStr: string | null | undefined): Date | null {
    if (!dateStr) return null;
    let normalized = dateStr;
    if (!normalized.endsWith("Z") && !normalized.includes("+")) {
        normalized += "Z";
    }
    return new Date(normalized);
}
